const initialState = {
  status: "invalid",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case "CLIENT_LOADING":
      return {
        ...state,
        status: "loading",
      };
    case "CLIENT_SUCCESS":
      return {
        ...state,
        status: "success",
        ...action
      };
    case "CLIENT_FAILURE":
      return {
        ...state,
        status: "failure",
      };
    default:
      return state;
  }
};